import { withNormalizedCredits } from '@/pipes/pinakes/pinakes.credits';
import { PinakesService } from '@/services/pinakes/pinakes';
import type { TPinakesCard, TPinakesGroupDetail, TPinakesResourceDetail } from '@/services/pinakes/pinakes.types';

/**
 * External resource cards from Pinakes. Network only: a card enriches a link the way its Open
 * Graph preview does, so nothing is written to IndexedDB. Every card leaves here with its
 * `credits` validated (`withNormalizedCredits`).
 */
export class PinakesApplication {
  private constructor() {}

  /** One link's card, or `null` when Pinakes has none (or is not configured). */
  static async fetchCardByUri(uri: string): Promise<TPinakesResourceDetail | null> {
    const card = await PinakesService.fetchCardByUri(uri);
    return card ? withNormalizedCredits(card) : null;
  }

  /** What the people who tagged the resource also referenced. */
  static async fetchRelated(id: string, limit: number): Promise<TPinakesCard[]> {
    const cards = await PinakesService.fetchRelated(id, limit);
    return cards.map(withNormalizedCredits);
  }

  /** A group's member cards, or `null` when the group is gone (or Pinakes is not configured). */
  static async fetchGroup(id: string): Promise<TPinakesGroupDetail | null> {
    const group = await PinakesService.fetchGroup(id);
    return group ? { ...group, members: group.members.map(withNormalizedCredits) } : null;
  }
}
